import Crud from '../views/VehicleType/Crud'
import Entity from '../views/VehicleType/Add'

let routes = {
    path: '/vehicle_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_types/add',
            name: 'NewVehicleType',
            component: Entity,
            meta: {
                pageTitle: 'vehicleType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicleType.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_types/edit/:id?',
            name: 'EditVehicleType',
            component: Entity,
            meta: {
                pageTitle: 'vehicleType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicleType.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_types',
            name: 'list-vehicle-types',
            component: Crud,
            meta: {
                pageTitle: 'vehicleType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicleType.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
